export const potatozNFTs = [
  {
    "id": "potatoz-9998",
    "name": "Potatoz #9998",
    "image": "https://grow-api.memeland.com/token/images/9998.gif",
    "price": "0.87 ETH"
  },
  {
    "id": "potatoz-9997", 
    "name": "Potatoz #9997",
    "image": "https://grow-api.memeland.com/token/images/9997.gif",
    "price": "0.92 ETH"
  },
  {
    "id": "potatoz-9996",
    "name": "Potatoz #9996", 
    "image": "https://grow-api.memeland.com/token/images/9996.gif",
    "price": "0.76 ETH"
  },
  {
    "id": "potatoz-9995",
    "name": "Potatoz #9995",
    "image": "https://grow-api.memeland.com/token/images/9995.gif", 
    "price": "1.05 ETH"
  },
  {
    "id": "potatoz-9994",
    "name": "Potatoz #9994",
    "image": "https://grow-api.memeland.com/token/images/9994.gif",
    "price": "0.68 ETH"
  },
  {
    "id": "potatoz-9993",
    "name": "Potatoz #9993",
    "image": "https://grow-api.memeland.com/token/images/9993.gif",
    "price": "0.95 ETH"
  },
  {
    "id": "potatoz-9992",
    "name": "Potatoz #9992",
    "image": "https://grow-api.memeland.com/token/images/9992.gif",
    "price": "0.82 ETH"
  },
  {
    "id": "potatoz-9991",
    "name": "Potatoz #9991",
    "image": "https://grow-api.memeland.com/token/images/9991.gif",
    "price": "0.63 ETH"
  },
  {
    "id": "potatoz-9990",
    "name": "Potatoz #9990",
    "image": "https://grow-api.memeland.com/token/images/9990.gif",
    "price": "1.08 ETH"
  },
  {
    "id": "potatoz-9989",
    "name": "Potatoz #9989",
    "image": "https://grow-api.memeland.com/token/images/9989.gif",
    "price": "0.71 ETH"
  },
  {
    "id": "potatoz-9988",
    "name": "Potatoz #9988",
    "image": "https://grow-api.memeland.com/token/images/9988.gif",
    "price": "0.89 ETH"
  },
  {
    "id": "potatoz-9987",
    "name": "Potatoz #9987",
    "image": "https://grow-api.memeland.com/token/images/9987.gif",
    "price": "0.54 ETH"
  },
  {
    "id": "potatoz-9986",
    "name": "Potatoz #9986",
    "image": "https://grow-api.memeland.com/token/images/9986.gif",
    "price": "1.10 ETH"
  },
  {
    "id": "potatoz-9985",
    "name": "Potatoz #9985",
    "image": "https://grow-api.memeland.com/token/images/9985.gif",
    "price": "0.78 ETH"
  },
  {
    "id": "potatoz-9984",
    "name": "Potatoz #9984",
    "image": "https://grow-api.memeland.com/token/images/9984.gif",
    "price": "0.93 ETH"
  },

  {
    "id": "potatoz-9983",
    "name": "Potatoz #9983",
    "image": "https://grow-api.memeland.com/token/images/9983.gif",
    "price": "0.85 ETH"
  },
  {
    "id": "potatoz-9982",
    "name": "Potatoz #9982",
    "image": "https://grow-api.memeland.com/token/images/9982.gif", 
    "price": "0.97 ETH"
  },
  {
    "id": "potatoz-9981",
    "name": "Potatoz #9981",
    "image": "https://grow-api.memeland.com/token/images/9981.gif",
    "price": "0.72 ETH"
  },
  {
    "id": "potatoz-9980",
    "name": "Potatoz #9980",
    "image": "https://grow-api.memeland.com/token/images/9980.gif",
    "price": "1.03 ETH"
  },
  {
    "id": "potatoz-9979",
    "name": "Potatoz #9979",
    "image": "https://grow-api.memeland.com/token/images/9979.gif",
    "price": "0.66 ETH"
  },
  {
    "id": "potatoz-9978",
    "name": "Potatoz #9978",
    "image": "https://grow-api.memeland.com/token/images/9978.gif",
    "price": "0.91 ETH"
  },
  {
    "id": "potatoz-9977",
    "name": "Potatoz #9977",
    "image": "https://grow-api.memeland.com/token/images/9977.gif",
    "price": "0.83 ETH"
  },
  {
    "id": "potatoz-9976",
    "name": "Potatoz #9976",
    "image": "https://grow-api.memeland.com/token/images/9976.gif",
    "price": "0.59 ETH"
  },
  {
    "id": "potatoz-9975",
    "name": "Potatoz #9975",
    "image": "https://grow-api.memeland.com/token/images/9975.gif",
    "price": "1.07 ETH"
  },
  {
    "id": "potatoz-9974",
    "name": "Potatoz #9974",
    "image": "https://grow-api.memeland.com/token/images/9974.gif",
    "price": "0.75 ETH"
  },
  {
    "id": "potatoz-9973",
    "name": "Potatoz #9973",
    "image": "https://grow-api.memeland.com/token/images/9973.gif",
    "price": "0.88 ETH"
  },
  {
    "id": "potatoz-9972",
    "name": "Potatoz #9972",
    "image": "https://grow-api.memeland.com/token/images/9972.gif",
    "price": "0.56 ETH"
  },
  {
    "id": "potatoz-9971",
    "name": "Potatoz #9971",
    "image": "https://grow-api.memeland.com/token/images/9971.gif",
    "price": "1.09 ETH"
  },
  {
    "id": "potatoz-9970",
    "name": "Potatoz #9970",
    "image": "https://grow-api.memeland.com/token/images/9970.gif",
    "price": "0.81 ETH"
  },
  {
    "id": "potatoz-9969",
    "name": "Potatoz #9969",
    "image": "https://grow-api.memeland.com/token/images/9969.gif",
    "price": "0.94 ETH"
  },
  {
    "id": "potatoz-9968",
    "name": "Potatoz #9968",
    "image": "https://grow-api.memeland.com/token/images/9968.gif",
    "price": "0.69 ETH"
  },
  {
    "id": "potatoz-9967",
    "name": "Potatoz #9967",
    "image": "https://grow-api.memeland.com/token/images/9967.gif",
    "price": "1.02 ETH"
  },
  {
    "id": "potatoz-9966",
    "name": "Potatoz #9966",
    "image": "https://grow-api.memeland.com/token/images/9966.gif",
    "price": "0.77 ETH"
  },
  {
    "id": "potatoz-9965",
    "name": "Potatoz #9965",
    "image": "https://grow-api.memeland.com/token/images/9965.gif",
    "price": "0.86 ETH"
  },
  {
    "id": "potatoz-9964",
    "name": "Potatoz #9964",
    "image": "https://grow-api.memeland.com/token/images/9964.gif",
    "price": "0.62 ETH"
  },
  {
    "id": "potatoz-9963",
    "name": "Potatoz #9963",
    "image": "https://grow-api.memeland.com/token/images/9963.gif",
    "price": "1.04 ETH"
  },
  {
    "id": "potatoz-9962",
    "name": "Potatoz #9962",
    "image": "https://grow-api.memeland.com/token/images/9962.gif",
    "price": "0.79 ETH"
  },
  {
    "id": "potatoz-9961",
    "name": "Potatoz #9961",
    "image": "https://grow-api.memeland.com/token/images/9961.gif",
    "price": "0.90 ETH"
  },
  {
    "id": "potatoz-9960",
    "name": "Potatoz #9960",
    "image": "https://grow-api.memeland.com/token/images/9960.gif",
    "price": "0.67 ETH"
  },
  {
    "id": "potatoz-9959",
    "name": "Potatoz #9959",
    "image": "https://grow-api.memeland.com/token/images/9959.gif",
    "price": "1.06 ETH"
  },
  {
    "id": "potatoz-9958",
    "name": "Potatoz #9958",
    "image": "https://grow-api.memeland.com/token/images/9958.gif",
    "price": "0.73 ETH"
  },
  {
    "id": "potatoz-9957",
    "name": "Potatoz #9957",
    "image": "https://grow-api.memeland.com/token/images/9957.gif",
    "price": "0.96 ETH"
  },
  {
    "id": "potatoz-9956",
    "name": "Potatoz #9956",
    "image": "https://grow-api.memeland.com/token/images/9956.gif",
    "price": "0.58 ETH"
  },
  {
    "id": "potatoz-9955",
    "name": "Potatoz #9955",
    "image": "https://grow-api.memeland.com/token/images/9955.gif",
    "price": "1.01 ETH"
  },
  {
    "id": "potatoz-9954",
    "name": "Potatoz #9954",
    "image": "https://grow-api.memeland.com/token/images/9954.gif",
    "price": "0.84 ETH"
  },
  {
    "id": "potatoz-9953",
    "name": "Potatoz #9953",
    "image": "https://grow-api.memeland.com/token/images/9953.gif",
    "price": "0.93 ETH"
  },
  {
    "id": "potatoz-9952",
    "name": "Potatoz #9952",
    "image": "https://grow-api.memeland.com/token/images/9952.gif",
    "price": "0.70 ETH"
  },
  {
    "id": "potatoz-9951",
    "name": "Potatoz #9951",
    "image": "https://grow-api.memeland.com/token/images/9951.gif",
    "price": "1.00 ETH"
  },
  {
    "id": "potatoz-9950",
    "name": "Potatoz #9950",
    "image": "https://grow-api.memeland.com/token/images/9950.gif",
    "price": "0.80 ETH"
  },
    
  {
    "id": "potatoz-9949",
    "name": "Potatoz #9949",
    "image": "https://grow-api.memeland.com/token/images/9949.gif",
    "price": "0.92 ETH"
  },
  {
    "id": "potatoz-9948",
    "name": "Potatoz #9948",
    "image": "https://grow-api.memeland.com/token/images/9948.gif",
    "price": "0.65 ETH"
  },
  {
    "id": "potatoz-9947",
    "name": "Potatoz #9947",
    "image": "https://grow-api.memeland.com/token/images/9947.gif",
    "price": "1.08 ETH"
  },
  {
    "id": "potatoz-9946",
    "name": "Potatoz #9946",
    "image": "https://grow-api.memeland.com/token/images/9946.gif",
    "price": "0.78 ETH"
  },
  {
    "id": "potatoz-9945",
    "name": "Potatoz #9945",
    "image": "https://grow-api.memeland.com/token/images/9945.gif",
    "price": "0.89 ETH"
  },
  {
    "id": "potatoz-9944",
    "name": "Potatoz #9944",
    "image": "https://grow-api.memeland.com/token/images/9944.gif",
    "price": "0.57 ETH"
  },
  {
    "id": "potatoz-9943",
    "name": "Potatoz #9943",
    "image": "https://grow-api.memeland.com/token/images/9943.gif",
    "price": "1.05 ETH"
  },
  {
    "id": "potatoz-9942",
    "name": "Potatoz #9942",
    "image": "https://grow-api.memeland.com/token/images/9942.gif",
    "price": "0.82 ETH"
  },
  {
    "id": "potatoz-9941",
    "name": "Potatoz #9941",
    "image": "https://grow-api.memeland.com/token/images/9941.gif",
    "price": "0.94 ETH"
  },
  {
    "id": "potatoz-9940",
    "name": "Potatoz #9940",
    "image": "https://grow-api.memeland.com/token/images/9940.gif",
    "price": "0.71 ETH"
  },
  {
    "id": "potatoz-9939",
    "name": "Potatoz #9939",
    "image": "https://grow-api.memeland.com/token/images/9939.gif",
    "price": "1.02 ETH"
  },
  {
    "id": "potatoz-9938",
    "name": "Potatoz #9938",
    "image": "https://grow-api.memeland.com/token/images/9938.gif",
    "price": "0.76 ETH"
  },
  {
    "id": "potatoz-9937",
    "name": "Potatoz #9937",
    "image": "https://grow-api.memeland.com/token/images/9937.gif",
    "price": "0.87 ETH"
  },
  {
    "id": "potatoz-9936",
    "name": "Potatoz #9936",
    "image": "https://grow-api.memeland.com/token/images/9936.gif",
    "price": "0.61 ETH"
  },
  {
    "id": "potatoz-9935",
    "name": "Potatoz #9935",
    "image": "https://grow-api.memeland.com/token/images/9935.gif",
    "price": "1.09 ETH"
  },
  {
    "id": "potatoz-9934",
    "name": "Potatoz #9934",
    "image": "https://grow-api.memeland.com/token/images/9934.gif",
    "price": "0.79 ETH"
  },
  {
    "id": "potatoz-9933",
    "name": "Potatoz #9933",
    "image": "https://grow-api.memeland.com/token/images/9933.gif",
    "price": "0.91 ETH"
  },
  {
    "id": "potatoz-9932",
    "name": "Potatoz #9932",
    "image": "https://grow-api.memeland.com/token/images/9932.gif",
    "price": "0.68 ETH"
  },
  {
    "id": "potatoz-9931",
    "name": "Potatoz #9931",
    "image": "https://grow-api.memeland.com/token/images/9931.gif",
    "price": "1.04 ETH"
  },
  {
    "id": "potatoz-9930",
    "name": "Potatoz #9930",
    "image": "https://grow-api.memeland.com/token/images/9930.gif",
    "price": "0.83 ETH"
  },
  {
    "id": "potatoz-9929",
    "name": "Potatoz #9929",
    "image": "https://grow-api.memeland.com/token/images/9929.gif",
    "price": "0.95 ETH"
  },
  {
    "id": "potatoz-9928",
    "name": "Potatoz #9928",
    "image": "https://grow-api.memeland.com/token/images/9928.gif",
    "price": "0.72 ETH"
  },
  {
    "id": "potatoz-9927",
    "name": "Potatoz #9927",
    "image": "https://grow-api.memeland.com/token/images/9927.gif",
    "price": "1.07 ETH"
  },
  {
    "id": "potatoz-9926",
    "name": "Potatoz #9926",
    "image": "https://grow-api.memeland.com/token/images/9926.gif",
    "price": "0.85 ETH"
  },
  {
    "id": "potatoz-9925",
    "name": "Potatoz #9925",
    "image": "https://grow-api.memeland.com/token/images/9925.gif",
    "price": "0.93 ETH"
  },
  {
    "id": "potatoz-9924",
    "name": "Potatoz #9924",
    "image": "https://grow-api.memeland.com/token/images/9924.gif",
    "price": "0.69 ETH"
  },
  {
    "id": "potatoz-9923",
    "name": "Potatoz #9923",
    "image": "https://grow-api.memeland.com/token/images/9923.gif",
    "price": "1.01 ETH"
  },
  {
    "id": "potatoz-9922",
    "name": "Potatoz #9922",
    "image": "https://grow-api.memeland.com/token/images/9922.gif",
    "price": "0.81 ETH"
  },
  {
    "id": "potatoz-9921",
    "name": "Potatoz #9921",
    "image": "https://grow-api.memeland.com/token/images/9921.gif",
    "price": "0.96 ETH"
  },
  {
    "id": "potatoz-9920",
    "name": "Potatoz #9920",
    "image": "https://grow-api.memeland.com/token/images/9920.gif",
    "price": "0.73 ETH"
  },
  {
    "id": "potatoz-9919",
    "name": "Potatoz #9919",
    "image": "https://grow-api.memeland.com/token/images/9919.gif",
    "price": "1.06 ETH"
  },
  {
    "id": "potatoz-9918",
    "name": "Potatoz #9918",
    "image": "https://grow-api.memeland.com/token/images/9918.gif",
    "price": "0.84 ETH"
  },
  {
    "id": "potatoz-9917",
    "name": "Potatoz #9917",
    "image": "https://grow-api.memeland.com/token/images/9917.gif",
    "price": "0.97 ETH"
  },
  {
    "id": "potatoz-9916",
    "name": "Potatoz #9916",
    "image": "https://grow-api.memeland.com/token/images/9916.gif",
    "price": "0.67 ETH"
  },
  {
    "id": "potatoz-9915",
    "name": "Potatoz #9915",
    "image": "https://grow-api.memeland.com/token/images/9915.gif",
    "price": "1.03 ETH"
  },
  {
    "id": "potatoz-9914",
    "name": "Potatoz #9914",
    "image": "https://grow-api.memeland.com/token/images/9914.gif",
    "price": "0.80 ETH"
  },
  {
    "id": "potatoz-9913",
    "name": "Potatoz #9913",
    "image": "https://grow-api.memeland.com/token/images/9913.gif",
    "price": "0.90 ETH"
  },
  {
    "id": "potatoz-9912",
    "name": "Potatoz #9912",
    "image": "https://grow-api.memeland.com/token/images/9912.gif",
    "price": "0.64 ETH"
  },
  {
    "id": "potatoz-9911",
    "name": "Potatoz #9911",
    "image": "https://grow-api.memeland.com/token/images/9911.gif",
    "price": "1.10 ETH"
  },
  {
    "id": "potatoz-9910",
    "name": "Potatoz #9910",
    "image": "https://grow-api.memeland.com/token/images/9910.gif",
    "price": "0.77 ETH"
  },
  {
    "id": "potatoz-9909",
    "name": "Potatoz #9909",
    "image": "https://grow-api.memeland.com/token/images/9909.gif",
    "price": "0.88 ETH"
  },
  {
    "id": "potatoz-9908",
    "name": "Potatoz #9908",
    "image": "https://grow-api.memeland.com/token/images/9908.gif",
    "price": "0.62 ETH"
  },
  {
    "id": "potatoz-9907",
    "name": "Potatoz #9907",
    "image": "https://grow-api.memeland.com/token/images/9907.gif",
    "price": "1.00 ETH"
  },
  {
    "id": "potatoz-9906",
    "name": "Potatoz #9906",
    "image": "https://grow-api.memeland.com/token/images/9906.gif",
    "price": "0.75 ETH"
  },
  {
    "id": "potatoz-9905",
    "name": "Potatoz #9905",
    "image": "https://grow-api.memeland.com/token/images/9905.gif",
    "price": "0.86 ETH"
  },
  {
    "id": "potatoz-9904",
    "name": "Potatoz #9904",
    "image": "https://grow-api.memeland.com/token/images/9904.gif",
    "price": "0.59 ETH"
  },
  {
    "id": "potatoz-9903",
    "name": "Potatoz #9903",
    "image": "https://grow-api.memeland.com/token/images/9903.gif",
    "price": "0.98 ETH"
  },
  {
    "id": "potatoz-9902",
    "name": "Potatoz #9902",
    "image": "https://grow-api.memeland.com/token/images/9902.gif",
    "price": "0.74 ETH"
  },
  {
    "id": "potatoz-9901",
    "name": "Potatoz #9901",
    "image": "https://grow-api.memeland.com/token/images/9901.gif",
    "price": "0.85 ETH"
  },
  {
    "id": "potatoz-9900",
    "name": "Potatoz #9900",
    "image": "https://grow-api.memeland.com/token/images/9900.gif",
    "price": "0.56 ETH"
  },
  {
    "id": "potatoz-9899",
    "name": "Potatoz #9899",
    "image": "https://grow-api.memeland.com/token/images/9899.gif",
    "price": "0.99 ETH"
  }




];